import { InquiryParams } from "../schemas/policy.types";

export const getUserPolicy =
    (isAdmin: boolean) =>
    (idClient: number | null): InquiryParams => {
        const hasFullAccess = isAdmin;

        let dateFrom: string | Date = "";
        let dateUntil: string | Date = "";

        if (!hasFullAccess) {
            const today = new Date();
            today.setMonth(today.getMonth() - 15);
            dateFrom = today;
            dateUntil = new Date();
        }

        return {
            page: 0,
            pageSize: 10,
            poliza: "",
            ramo: 0,
            aseg: 0,
            comp: 0,
            desde: dateFrom,
            hasta: dateUntil,
            sorted: [],
            cdCliente: idClient,
            inclEjecutivo: false,
            cdEjecutivoAdm: 0,
            cdEjecutivo: 0,
            cdPool: null,
        };
    };
